import React from 'react'

/*
 * Outlined hexagon with an exclamation mark — External Exposure.
 *
 * Same hexagon geometry as the filled WarningIcon in this folder, so the two
 * read as one family. Corners are softened with strokeLinejoin="round" rather
 * than hand-built arcs, which keeps the path honest to the original vertices.
 */
const HexAlertIcon = ({ width, height, fill = '#3063FD' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19.2 19.2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.664 2.1 2.66 6.093v8.052l7.004 3.994 7.012-3.994V6.093L9.664 2.1Z"
      stroke={fill}
      strokeWidth="1.4"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
    <path d="M9.664 6.4v4.75" stroke={fill} strokeWidth="1.4" strokeLinecap="round" />
    <circle cx="9.664" cy="13.55" r="0.85" fill={fill} />
  </svg>
)

export default HexAlertIcon
